
/*
 *  This file app.module.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { getBaseLocationForBaseHref } from './global/util/basehref.util';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpService } from './global/services/http-service';
import { SharedService } from './global/services/shared.service';
import { SnackbarAlertService } from './global/services/snackbar-alert.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClientErrorHandler } from './global/services/error-handler/client-error-handler.service';
import { ServerErrorHandler } from './global/services/error-handler/server-error-handler.service';
import { LogErrorsService } from './global/services/error-handler/log-errors';

import { SnackbarComponent } from './global/components/snackbar/snackbar.component';
import { ProgressButtonService } from './global/services/progress-button.service';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

import { FileUploadService } from './global/services/file-upload.service';
import { ConfigurationService } from './global/services/configuration.service';
import { HroneNetworkInterceptor } from './global/services/interceptor/hrone-network.interceptor';
import { DialogModule } from 'primeng/dialog';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { UserAvatarComponent } from './global/components/user-avatar/user-avatar.component';

@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSnackBarModule,
        SnackbarComponent,
        ConfirmDialogModule,
        DialogModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        UserAvatarComponent
    ],
    providers: [
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura
            }
        }),
        ScreenTrackingService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HroneNetworkInterceptor,
            multi: true
        },
        HttpService,
        SharedService,
        SnackbarAlertService,
        ProgressButtonService,
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseLocationForBaseHref
        },
        {
            provide: ErrorHandler,
            useClass: ClientErrorHandler
        },
        ServerErrorHandler,
        LogErrorsService,
        ConfirmationService,
        FileUploadService,
        ConfigurationService,
        {
            provide: APP_INITIALIZER,
            useFactory: (ds: ConfigurationService) => function () {
                return ds.loadConfig();
            },
            deps: [ConfigurationService],
            multi: true
        },
        Title,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }

